// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeleteSupportiveMedication() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.supportiveMedications.delete(payload), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}

export function useConfirmDeleteSupportiveMedication() {
  const {t: tSupportive} = useTranslate('supportive-medications')
  const deleteSupportiveMedication = useDeleteSupportiveMedication()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={tSupportive('delete_supportive_medication_dialog.title')}
            description={tSupportive('delete_supportive_medication_dialog.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deleteSupportiveMedication(payload)
      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [tSupportive, deleteSupportiveMedication]
  )
}
